module.exports = __webpack_public_path__ + "static/drawing-07b27e62d6b1fa3cc5b41b7f39db5ccb.svg";